import { getContextPath } from '@mmw/contextual-config';
import { createBrowserHistory } from 'history';

export default createBrowserHistory({
  basename: getContextPath(),
});
